module.exports = __webpack_public_path__ + "assets/images/logo.png";


//////////////////
// WEBPACK FOOTER
// ./app/common/header/images/logo.png
// module id = R5Ds
// module chunks = 1